import core from "@gtmhub/core/module";
import { AnnouncementService } from "./services/announcements.service";

export default angular.module("announcements", [core]).service("AnnouncementService", AnnouncementService).name;
